import {gql} from '@apollo/client';

export const boardMutations = {
    REMOVE_BOARDS_BY_WORKSPACE_ID: gql`
        #For Removing Board
        mutation RemoveBoardById($workspaceId: String!) {
            removeBoardsByWorkspaceId(id: $id) {
                statusCode
                message
                success
                data
            }
        }
    `,
    REMOVE_RANGE_BOARDS_BY_WORKSPACE_ID: gql`
        #For Removing Board
        mutation RemoveRangeBoardsByWorkspaceId($ids: [String!]!, $workspaceId: String!) {
            removeRangeBoardsByWorkspaceId(workspaceId: $workspaceId, ids: $ids) {
                statusCode
                message
                success
                data
            }
        }
    `,
    REMOVE_BOARDS_BY_IDS: gql`
        #For Removing Board
        mutation RemoveBoardsByIds($ids: [String!]!) {
            removeBoardsByIds(ids: $ids) {
                statusCode
                message
                success
                data
            }
        }
    `,
    ADD_USERS_TO_BOARD: gql`
        #For Adding Users To Board
        mutation AddUsersToBoard($request: UserIdsForBoardRequestInput!) {
            addUsersToBoard(request: $request) {
                statusCode
                message
                success
                data
            }
        }
    `,
    REMOVE_USERS_FROM_BOARD: gql`
        #For Removing Users From Board
        mutation RemoveUsersFromBoard($request: UserIdsForBoardRequestInput!) {
            removeUsersFromBoard(request: $request) {
                statusCode
                message
                success
                data
            }
        }
    `,
    UPDATE_BOARD: gql`
        mutation UpdateBoard($id: UUID!, $input: BaordCreateEditDTOInput!) {
            updateBoard(id: $id, input: $input) {
                id
                title
                description
            }
        }
    `,
    UPDATE_USER_BOARD_TO_BE_SELECTED: gql`
        mutation UpdateUserBoardToBeSelected($workspaceId: UUID!, $boardId: UUID!) {
            updateUserBoardToBeSelected(workspaceId: $workspaceId, boardId: $boardId) {
                statusCode
                message
                success
                data
            }
        }
    `,
};
